var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBTikTok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m263.6672,155.2198c-1.694.1643-3.3944.2505-5.0964.2585-18.6673.0023-36.0782-9.4071-46.3039-25.0246v85.2145c0,34.7839-28.1984,62.9817-62.9817,62.9817s-62.9817-28.1979-62.9817-62.9817,28.1979-62.9823,62.9817-62.9823h0c1.3143,0,2.5999.1189,3.8924.1999v31.0368c-1.2925-.1557-2.5632-.3918-3.8924-.3918-17.7532,0-32.1449,14.3916-32.1449,32.1443s14.3917,32.1449,32.1449,32.1449,33.4368-13.9895,33.4368-31.7456l.3102-144.7243h29.6926c2.7999,26.6267,24.2699,47.424,50.9718,49.3765v34.4932"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBTikTok);
export default __webpack_public_path__ + "static/media/B_TikTok.e9ad2d4e41b3cd432478cec60a6e76e1.svg";
export { ForwardRef as ReactComponent };